<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16.0003 3.66675C9.18881 3.66675 3.66699 9.18857 3.66699 16.0001C3.66699 22.8116 9.18881 28.3334 16.0003 28.3334C22.8118 28.3334 28.3337 22.8116 28.3337 16.0001C28.3337 9.18857 22.8118 3.66675 16.0003 3.66675ZM1.66699 16.0001C1.66699 8.084 8.08424 1.66675 16.0003 1.66675C23.9164 1.66675 30.3337 8.084 30.3337 16.0001C30.3337 23.9162 23.9164 30.3334 16.0003 30.3334C8.08424 30.3334 1.66699 23.9162 1.66699 16.0001ZM19.4357 10.8214C20.4152 11.3973 21.0003 12.4809 21.0003 14.1334C21.0003 15.7859 20.4152 16.8695 19.4357 17.4454C18.602 17.9357 17.6521 17.9342 17.1918 17.9335C17.1749 17.9334 17.1587 17.9334 17.1431 17.9334H14.3337V20.6667C14.3337 21.219 13.8859 21.6667 13.3337 21.6667C12.7814 21.6667 12.3337 21.219 12.3337 20.6667V11.3334C12.3337 10.7811 12.7814 10.3334 13.3337 10.3334H17.1431C17.1587 10.3334 17.1749 10.3334 17.1918 10.3334C17.6521 10.3326 18.602 10.3312 19.4357 10.8214ZM14.3337 15.9334H17.1431C17.6564 15.9334 18.0958 15.9132 18.422 15.7214C18.633 15.5973 19.0003 15.2809 19.0003 14.1334C19.0003 12.9859 18.633 12.6695 18.422 12.5454C18.0958 12.3537 17.6564 12.3334 17.1431 12.3334H14.3337V15.9334Z"
			fill="#000"
		/>
	</svg>
</template>
